import axios from "axios";
import { getAuthCookie } from "./cookie-manager";

const baseURL = process.env.REACT_APP_API_URL;
const user = getAuthCookie();

const instance = axios.create({
  baseURL,
  headers: {
    authorization: user?.token ? `Bearer ${user.token}` : "",
  },
});

export default instance;
